interface Column {
  id: string;
  label: string;
  minWidth?: string;
  maxWidth?: string;
  width?: string;
  align?: "center" | "left" | "right" | "inherit" | "justify";
  formatString?: (value: string) => string;
}

export const userLogsTableColumns: readonly Column[] = [
  { id: "thread", label: "Thread" },
  { id: "createdAt", label: "Created On" },
  { id: "status", label: "Status" },
  {
    id: "view",
    label: "View",
    align: "center",
    width: "128px",
  },
];

export const getAuthorName = (params: {
  createdBy: string;
  userName?: string;
}) => {
  const { createdBy, userName } = params;

  const authors = {
    bot: "Sidekick",
    system: "System",
    user: userName,
  };
  return authors[createdBy as keyof typeof authors] ?? userName ?? createdBy;
};

export const getFormattedMessageText = (data: any) => {
  try {
    return `~~~json\n${JSON.stringify(data, null, 2)}`;
  } catch (error) {
    console.error(error);
    return "Error trying to load the data.";
  }
};

export const getFormattedAction = (action: string) => {
  return action.replace(/-/g, " ");
};
